export const selectCurrentVersionChanges = state => state.changeLog.currentVersionChanges;

export const selectIsChangeLogLoading = state => state.changeLog.isCHangeLogLoading;